"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheCoreTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const curators = [{
    name: "Alex Rivera",
    title: "LEAD HACKATHON COORDINATOR",
    bio: "Alex manages our high-intensity coding marathons, ensuring every participant has the resources and mentorship to ship their best work.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/hackathon_lead.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/hackathon_lead.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/hackathon_lead.png-wvc-sizes"
  }, {
    name: "Jordan Chen",
    title: "HARDWARE LAB MANAGER",
    bio: "Jordan oversees our physical computing space, maintaining the 3D printers, soldering stations, and robotics kits for all members.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/hardware_lab.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/hardware_lab.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/hardware_lab.png-wvc-sizes"
  }, {
    name: "Sam Taylor",
    title: "COMMUNITY ARCHITECT",
    bio: "Sam fosters our digital ecosystem, moderating our Discord channels and organizing the weekly project-building nights that define us.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/community_architect.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/community_architect.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/community_architect.png-wvc-sizes"
  }, {
    name: "Morgan Lee",
    title: "OPEN SOURCE ADVOCATE",
    bio: "Morgan curates our monthly toolkit releases, ensuring our community stays at the cutting edge of modern development practices.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/open_source_lead.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/open_source_lead.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/open_source_lead.png-wvc-sizes"
  }, {
    name: "Casey Quinn",
    title: "WORKSHOP DIRECTOR",
    bio: "Casey designs our curriculum, bringing in industry experts to lead deep-dive sessions on everything from Rust to AI deployment.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/workshop_director.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/workshop_director.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/workshop_director.png-wvc-sizes"
  }, {
    name: "Riley Vance",
    title: "PROJECT MENTOR",
    bio: "Riley provides one-on-one guidance for members building their first passion projects, turning complex bugs into learning opportunities.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/project_mentor.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/project_mentor.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/project_mentor.png-wvc-sizes"
  }];
  return <section data-section-id="2175" id="the-core-team" className="bg-background text-foreground py-20 md:py-28 px-4 md:px-8">
      <div ref={ref} className={`mx-auto max-w-7xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="text-center mb-16 md:mb-20">
          <p className="font-mono text-[0.7rem] md:text-xs tracking-[0.3em] uppercase mb-6" style={{
          color: "var(--chart-1)"
        }}>
            The Builders Behind Code Hub
          </p>
          <h2 className="font-default text-4xl md:text-5xl lg:text-[3rem] font-light text-foreground leading-tight">
            Our <em className="italic font-normal">Leadership</em>
          </h2>

          {}
          <div className="flex items-center justify-center gap-4 mt-8">
            <Separator className="w-16 md:w-24 h-px" style={{
            backgroundColor: "var(--chart-1)"
          }} />
            <span className="font-default text-lg italic" style={{
            color: "var(--chart-1)"
          }} aria-hidden="true">
              &#10086;
            </span>
            <Separator className="w-16 md:w-24 h-px" style={{
            backgroundColor: "var(--chart-1)"
          }} />
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-7 md:gap-x-7">
          {curators.map((curator, i) => {
          const rowOffset = i >= 3 ? "md:mt-8" : "";
          const thirdInRowOffset = i === 2 || i === 5 ? "md:mt-4" : "";
          return <div key={i} data-index={i} className={`group flex flex-col ${rowOffset} ${thirdInRowOffset}`}>
                {}
                <div className="relative overflow-hidden rounded-lg border border-border">
                  <div className="aspect-[3/4] overflow-hidden">
                    <img src={curator.image} data-wvc-srcset={curator.srcset} data-wvc-sizes={curator.sizes} alt={`Portrait of ${curator.name}`} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]" style={{
                  filter: "sepia(0.15) saturate(0.9)"
                }} />
                  </div>
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
                background: "linear-gradient(180deg, transparent 40%, hsl(270 100% 64% / 0.15) 100%)"
              }} />
                </div>

                {}
                <div className="pt-6 px-1">
                  <p className="font-mono text-[0.65rem] tracking-[0.25em] uppercase mb-3" style={{
                color: "var(--chart-1)"
              }}>
                    {curator.title}
                  </p>

                  <h3 className="font-default text-2xl md:text-[1.625rem] font-normal text-foreground mb-3 leading-tight transition-all duration-300">
                    <span className="bg-[length:0%_1px] bg-no-repeat bg-bottom group-hover:bg-[length:100%_1px] transition-[background-size] duration-500" style={{
                  backgroundImage: "linear-gradient(var(--chart-1), var(--chart-1))"
                }}>
                      {curator.name}
                    </span>
                  </h3>

                  <p className="font-sans text-[0.8125rem] leading-relaxed text-muted-foreground mb-5 line-clamp-3">
                    {curator.bio}
                  </p>

                  <Link to="/JoinUsPage" className="inline-flex items-center gap-1.5 font-mono text-[0.7rem] tracking-[0.2em] uppercase pb-1 border-b transition-colors duration-300 hover:opacity-80" style={{
                color: "var(--chart-1)",
                borderColor: "var(--chart-1)"
              }}>
                    View full profile
                    <ArrowUpRight className="size-3" />
                  </Link>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}